<template>
    <avue-crud
    :option="option"
    :table-loading="tableLoading"
    :data="tableData"
    :page="page"
    v-model="modelForm"
    ref="crud"
    @row-update="rowUpdate"
    @search-change="searchChange"
    @search-reset="searchReset"
    @current-change="currentChange"
    @size-change="sizeChange"
    @sort-change="sortChange"
    @on-load="onLoad"
    @refresh-change="refresh"
    @current-row-change="handleRowClick"
    >
    <!-- 操作按钮扩展 -->
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          @click="Initialize"
        >初始化</el-button>
      </template>
    <!--操作栏目-->
    <template slot-scope="{type,size,row}" slot="menu">
      <!-- 查看按钮 -->
      <el-tooltip v-if="row.type !== 'publicRule'" content="查看" placement="bottom" effect="light">
        <el-button circle @click="$refs.crud.rowView(row,row.$index)" :size="size" :type="type" icon="el-icon-view"></el-button>
      </el-tooltip>
      <!-- 编辑按钮 -->
       <el-tooltip v-if="row.type !== 'publicRule'" content="编辑" placement="bottom" effect="light">
        <el-button circle @click="$refs.crud.rowEdit(row,row.$index)" :size="size" :type="type" icon="el-icon-edit"></el-button>
      </el-tooltip>
    </template>
    <!-- 单元格行内  -->
    <template v-slot:authority="{row}" >
      <el-tag type="success" v-if="row.authority === 'allOpen'">开放</el-tag>
      <el-tag type="info" v-if="row.authority === 'close'">不开放</el-tag>
      <el-tag type="warning" v-if="row.authority === 'read'">可读</el-tag>
      <el-tag type="danger" v-if="row.authority === 'write'">可读可写</el-tag>
    </template>
    <template v-slot:type="{row}" >
      <el-tag type="success" v-if="row.type === 'table'">表格</el-tag>
      <el-tag type="info" v-if="row.type === 'view'">视图</el-tag>
      <el-tag type="warning" v-if="row.type === 'publicRule'">通用规则</el-tag>
    </template>
    </avue-crud>
</template>

<script>

export default {
  data() {
    return {
      tableLoading: false,
      tableData: [],
      dataSourceList: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      query: {},
      order: {
        oder: '',
        prop: ''
      },
      modelForm: {},
      isFirst: true,
      option: {
        index: true,
        highlightCurrentRow: true,
        page: false,
        height: '200',
        align: 'center',
        menuAlign: 'center',
        searchMenuSpan: 4,
        addBtn: false,
        delBtn: false,
        viewBtn: false,
        editBtn: false,
        menuType: 'icon',
        column: [
          {
            label: '数据源',
            prop: 'dataSourceId',
            search: false,
            type: 'select',
            editDisabled: true,
            slot: false,
            width: 100,
            sortable: false,
            dicData: []
          },
          {
            label: '表名',
            sortable: true,
            prop: 'dbNameAndTableName',
            search: true,
            editDisabled: true
          },
          {
            label: '表注释',
            sortable: true,
            prop: 'tableComment',
            search: true
          }, {
            label: '类型',
            prop: 'type',
            search: true,
            type: 'select',
            editDisabled: true,
            slot: true,
            width: 100,
            sortable: true,
            dicData: [{
              label: '表',
              value: 'table'
            }, {
              label: '视图',
              value: 'view'
            }, {
              label: '通用规则',
              value: 'publicRule'
            }]
          }, {
            label: '权限',
            prop: 'authority',
            search: true,
            sortable: true,
            width: 100,
            type: 'select',
            slot: true,
            dicData: [{
              label: '不开放',
              value: 'close'
            }, {
              label: '开放',
              value: 'allOpen'
            }, {
              label: '可读',
              value: 'read'
            }, {
              label: '可读可写',
              value: 'write'
            }]
          }, {
            label: '备注',
            prop: 'remark',
            span: 24,
            type: 'textarea'
          }
        ]
      }
    }
  },
  components: {},
  mounted() {
    this.getDataSourceList()
  },
  methods: {
    getDataSourceList() {
      const params = {}
      this.$http.post('/fighter-workflow-saas/multiple-database/query', {
        'entity': {
          'status': 1
        }
      }, {
        params: {
          pageNum: params.pageNum || 1,
          pageSize: params.pageSize || 9999
        }
      }).then(response => {
        response.data.records.forEach((val, index) => {
          this.dataSourceList.push({
            label: val.dbCode,
            value: val.id
          })
        })
        this.option.column[0].dicData = this.dataSourceList
      }).catch(error => {
        this.$message.error(error.msg)
      })
    },
    onLoad(page = this.page, params = this.query, order = this.order) {
      let orderItemList = []
      if (order.order) {
        orderItemList.push({
          asc: order.oder === 'ascending',
          column: order.prop
        })
      }
      this.tableLoading = true
      this.$http.post('/t-data-collection-resource/query', { 'entity': params, orderItemList }, { params: {
        pageNum: page.currentPage,
        pageSize: page.pageSize
      }}).then(
        response => {
          this.tableLoading = false
          this.tableData = response.data.records
          this.page.total = response.data.total || response.data.records.length
          if (this.isFirst) {
            if (this.tableData.length > 0) {
              this.$emit('rowClick', this.tableData[0])
            }
            this.isFirst = false
          }
        }
      ).catch(
        error => {
          this.tableLoading = false
          this.$message.error(error.msg || error.message)
        }
      )
    },
    // 编辑行
    rowUpdate(row, index, loading, done) {
      this.$http.put('/t-data-collection-resource', row)
        .then(response => {
          this.$message.success('编辑成功') && loading()
          this.onLoad()
        }).catch(error => {
          this.$message.error(error.msg || error.message) && done()
        })
    },
    // 搜索改变事件
    searchChange(params, done) {
      for (let key in params) {
        if (params[key] === '') delete params[key]
      }
      done()
      this.page.currentPage = 1
      this.query = params
      this.onLoad()
    },
    // 搜索重置
    searchReset() {
      this.query = {}
      this.page.currentPage = 1
      this.onLoad()
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    // 排序改变
    sortChange(value) {
      this.order.prop = value.prop
      this.order.order = value.order
      this.onLoad()
    },
    refresh: function() {
      this.onLoad()
    },
    Initialize() {
      this.$confirm('确定要进行初始化吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/t-data-collection-resource/init-resource', null, {
          params: {}
        }).then(res => {
          this.$message.success('初始化成功')
          this.onLoad()
        }).catch(error => {
          this.$message.error(error.msg || error.message)
        })
      }).catch(e => {})
    },
    handleRowClick: function(row) {
      this.chooseRowId = row.id
      this.$emit('rowClick', row)
    }
  }
}

</script>
<style lang='scss' scoped>

</style>
